// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__232dC","header":"ReportDetails_header__1TWiA","title":"ReportDetails_title__19TfN","left":"ReportDetails_left__Q8Kgg"};